import { render, staticRenderFns } from "./showQuestionary.vue?vue&type=template&id=5c197c1a&"
import script from "./showQuestionary.vue?vue&type=script&lang=js&"
export * from "./showQuestionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports